import React, { useMemo, useState } from 'react';
import { BUCKET_URL } from '../utils/env-utils';

interface SafeFlightLogoProps {
  mainFlightNumber: string;     // e.g. "MH113"
  dimension: string;            // e.g. "0180x0045"
  logoSize?: { width: number; height: number };
}

const SafeFlightLogo: React.FC<SafeFlightLogoProps> = ({ mainFlightNumber, dimension, logoSize }) => {
  const airlineCode = useMemo(() => mainFlightNumber.split(' ')[0], [mainFlightNumber]);
  const basePath = useMemo(
    () => `${BUCKET_URL}/${dimension}/P${airlineCode}${dimension.replace('x', '')}`,
    [airlineCode, dimension]
  );

  const [src, setSrc] = useState<string>(`${basePath}.bmp`);
  const [triedJpg, setTriedJpg] = useState(false);
  const [visible, setVisible] = useState(true);

  const handleError = () => {
    if (!triedJpg) {
      // fallback to .jpg once
      setTriedJpg(true);
      setSrc(`${basePath}.jpg`);
    } else {
      // both failed → hide
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <img
      key={`${airlineCode}-${dimension}`}
      src={src}
      alt={`Logo ${airlineCode}`}
      width={logoSize?.width}
      height={logoSize?.height}
      onError={handleError}
      onLoad={() => setVisible(true)}
    />
  );
};

export default SafeFlightLogo;
